import { styled } from '@mui/material/styles';
export const WrapperSwitchField = styled('div')`
  display: flex;
  flex-direction: column;
`;
